export const getLanguageId = (state) => state.languages.current.id || 1
export const getCurrentLanguage = (state) => state.languages.current
